/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {

  async fetchTotalEquipmentOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/equipmentOrder/getTotalEquipmentOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_EQUIPMENT_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },


  async fetchEquipmentOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/equipmentOrder/getEquipmentsOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_EQUIPMENT_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewEquipmentOrder({ commit }, payload) {

    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/equipmentOrder/save`, payload.order)
      payload.order.idEquipmentOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_EQUIPMENT_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    //router.push(`/equipamentos`).catch(() => { });
  },
 


  async removeEquipmentOrder({ commit }, payload) {
    let idEquipmentOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/equipmentOrder/remove`, { idEquipmentOrder })
      payload.loading.close()
      commit('REMOVE_EQUIPMENT_ORDER', idEquipmentOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateEquipmentOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/equipmentOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_EQUIPMENT_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/equipamentos`).catch(err => { });
  },

  async trashEquipmentOrder({ commit }, payload) {
    let idEquipmentOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(
        `${baseApiUrl}/equipmentOrder/trash`,{ idEquipmentOrder }
      )
      payload.loading.close()
      commit('REMOVE_EQUIPMENT_ORDER', idEquipmentOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },

  async fetchEquipmentOrderByPeriod({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.post(
        `${baseApiUrl}/equipmentOrder/getEquipmentsOrderedByPeriod`,
        payload.data
      );
      payload.loading.close()
      commit('SET_EQUIPMENT_ORDER_FILTERED', response.data)
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/equipamentos").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },

  async trashFilteredEquipmentOrder({ commit }, payload) {
    let idEquipmentOrder = payload.idOrder
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/equipmentOrder/trash`,{ idEquipmentOrder }
      )
      payload.loading.close()
      commit('REMOVE_EQUIPMENT_ORDER_FILTERED', idEquipmentOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/equipamentos").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },
}
